import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SlidePanelService } from './slide-panel.service';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'idl-slide-panel-host',
  standalone: true,
  imports: [CommonModule, CdkPortalOutlet, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: './slide-panel-host.component.html',
  styleUrl: './slide-panel-host.component.scss',
  providers: [provideTranslocoScope('sharedInputs')],
  animations: [
    trigger('slideIn', [
      state('void', style({ transform: 'translateX(100%)' })),
      state('open', style({ transform: 'translateX(0)' })),
      transition('void => open', [animate('0.25s ease-out')]),
      transition('open => void', [animate('0.2s ease-in')]),
    ]),
  ],
})
export class SlidePanelHostComponent {
  readonly slidePanelService = inject(SlidePanelService);
}
